import React from 'react'

function BlogsExplorePage() {
    return (
        <div>
            <p className='blog-explore-page-head'> Welcome to the Blog </p>
        </div>
    )
}

export default BlogsExplorePage